import React, {useEffect} from "react";
import Styles from './styles.module.scss'

import Seo from "../../../components/_UI/seo";
import {useTranslation} from "react-i18next";

import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {getLastLog} from "../../../store/cabinet/action";
import CabinetSettingsMain from "../../../components/cabinet/cabinetSettingsMain";
import CabinetSettingsChange from "../../../components/cabinet/cabinetSettingsChange";
import CabinetSettingsProtection from "../../../components/cabinet/cabinetSettingsProtection";
import CabinetSettingsChangePasswordModal from "../../../components/cabinet/cabinetSettingsChangePasswordModal";
import CabinetSettingsChangeWalletModal from "../../../components/cabinet/cabinetSettingsChangeWalletModal";
import CabinetSettingsChangeEmailModal from "../../../components/cabinet/cabinetSettingsChangeEmailModal";




const CabinetSettingsPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-in');
        }
    },[authStatus, navigate])

    useEffect(()=>{
        if (authStatus){
            dispatch(getLastLog());
        }
    },[authStatus, dispatch])

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Настройки')}/>
            <div className={`${Styles.posWrap}`}>
                <CabinetSettingsMain/>
                <CabinetSettingsChange/>
                <CabinetSettingsProtection/>
                <CabinetSettingsChangePasswordModal/>
                <CabinetSettingsChangeWalletModal/>
                <CabinetSettingsChangeEmailModal/>
            </div>
        </section>
    );
};

export default CabinetSettingsPage;